module.exports = __webpack_public_path__ + "media/images/pc/plans/search_form/location_type_resort_sola@2x-d0b5a0925780a7f4b1abd80b1d7db642.webp";